import { NgModule } from "@angular/core";
import { ThemeComponent } from "./theme.component";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "../auth/_guards/auth.guard";
// import { SharedModule } from "../freightconfirmation/app.sharemodule";
import { NewDesignLayoutComponent } from "../shared/components/new-design-layout/new-design-layout.component";
import { environment } from "../../environments/environment";

const routes: Routes = [
  {
    path: "",
    component: ThemeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "index",
        loadChildren:
          "./pages/default/dashboard/dashboard.module#DashboardModule",
        //'loadChildren': '.\/pages\/default\/dashboard\/dashboard.module#DashbaordModule'
      },
      // {
      //   path: "home",
      //   loadChildren: "../newModule/new.module#newModule"
      // },
      {
        path: "exception",
        loadChildren:
          "./pages/default/exception-dashboard/exception.module#ExceptionDashboardModule",
      },
      //Added By Ketan on 23-Nov-2020
      {
        path: "customer",
        loadChildren:
          "./pages/default/customer-dashboard/customer.module#CustomerDashboardModule",
      },
      //Ended By Ketan 0n 23-Nov-2020

      //Added By Ketan on 23-Nov-2020
      {
        path: "transporter",
        loadChildren:
          "./pages/default/transporter-dashboard/transporter.module#TransporterDashboardModule",
      },
      //Ended By Ketan 0n 23-Nov-2020

      {
        path: "management",
        loadChildren:
          "./pages/default/management/management.module#ManagementModule",
      },
      {
        path: "",
        redirectTo:
          environment.apiUrl == "https://sawariya.ifreightbox.net/" ||
            environment.apiUrl == "https://ximble.ifreightbox.net/"
            ? "index2"
            : "index",
        pathMatch: "full",
      },
      //fullcalendar
      {
        path: "calendar",
        loadChildren: "../fullcalendar/fullcalendar.module#FullcalendarModule",
      },
      // Freight search
      {
        path: "freight",
        loadChildren:
          "../freight-search/freight-search.module#FreightSearchModule",
      },
      // Beats
      {
        path: "beats",
        loadChildren: "../beats/beats.module#BeatsModule",
      },
      // Rate Check [added vithujan 27-07-2022]
      {
        path: "rate-check",
        loadChildren: "../rate-check/rate-check.module#RateCheckModule",
      },
      {
        path: "settings",
        loadChildren: "../Masters/settings/settings.module#SettingsModule",
      },
      //added by rahul 03-11-2023
      // {
      //   path: "NewReasonMaster",
      //   loadChildren: "../Masters/New-ReasonMaster/new-reasonmaster/new-reasonmaster.module#NewReasonmasterModule",
      // },

      {
        path: "ReasonMaster",
        loadChildren:
          "../Masters/reason-master/reason-master.module#ReasonMasterModule",
      },

      //added by rahul tally reports 30-10-2023
      {
        path: "Detailedreport",
        loadChildren:
          "../Masters/detailed-report/report-nav/report-nav.module#ReportNavModule",
      },

      {
        path: "menu",
        loadChildren:
          "../Masters/detailed-report/report-nav/report-nav.module#ReportNavModule",
      },
      {
        path: "report",
        loadChildren:
          "../Masters/detailed-report/report/report.module#ReportModule",
      },

      {
        path: "report-main",
        loadChildren:
          "../Masters/detailed-report/report-main/report-main.module#ReportMainModule",
      },
      {
        path: "transaction-detail",
        loadChildren:
          "../Masters/detailed-report/transaction-details/transaction-details.module#TransactionDetailsModule",
      },
      {
        path: "report-detail",
        loadChildren:
          "../Masters/detailed-report/report-detail/report-detail.module#ReportDetailModule",
      },

      //end
      {
        path: "company",
        loadChildren: "../Masters/company/company.module#CompanyModule",
      },
      // {
      //   path: "NewCompany",
      //   loadChildren: "../Masters/new-company/company-list.module#companyListModule",
      // },
      // Feedback
      {
        path: "feedback",
        loadChildren: "../feedback/feedback.module#FeedbackModule",
      },
      // Star-rating
      {
        path: "rating",
        loadChildren: "../starrating/starrating.module#StarratingModule",
      },
      {
        path: "Pickup-Req",
        loadChildren:
          "../Orders/pickup-req/pickupreq-entry.module#PickupreqEntryModule",
      },
      //added by maaria
      // {
      //   path: "LiveOrderTrack",
      //   loadChildren:
      //     "../Orders/live-order-track/live-order-track.module#LiveOrderTrackModule",
      // },
      {
        path: "user",
        loadChildren: "../Masters/user/user.module#UserModule",
      },
      {
        path: "region",
        loadChildren: "../Masters/region/region.module#RegionModule",
      },
      // {
      //     'path': 'businesstype',
      //     'loadChildren': '..\/Masters\/businesstype\/businesstype.module#BusinesstypeComponent'
      // },
      {
        path: "sector",
        loadChildren: "../Masters/sector/sector.module#SectorModule",
      },
      {
        path: "business",
        loadChildren: "../Masters/business/business.module#BusinessModule",
      },
      {
        path: "carrier",
        loadChildren: "../Masters/carrier/carrier.module#CarrierModule",
      },
      {
        path: "shipmentmode",
        loadChildren:
          "../Masters/shipmentmode/shipmentmode.module#ShipmentmodeModule",
      },

      {
        path: "vehicletype",
        loadChildren:
          "../Masters/vehicletype/vehicletype.module#VehicleTypeModule",
      },
      // {
      //   path: "Products",
      //   loadChildren:
      //     "../Masters/Products/products.module#ProductsModule",
      // },
      {
        path: "Pickup-Req",
        loadChildren:
          "../Orders/pickup-req/pickupreq-entry.module#PickupreqEntryModule",
      },
      {
        path: "transportservices",
        loadChildren:
          "../Masters/transportservices/transportservices.module#TransportServicesModule",
      },
      {
        path: "item",
        loadChildren: "../Masters/item/item.module#ItemModule",
      },
      {
        path: "fuel",
        loadChildren: "../Masters/fuel/fuel.module#FuelModule",
      },
      {
        path: "FuelPricePumpWise",
        loadChildren:
          "../Masters/fuelPricePumpWise/fuelPricePumpWise.module#FuelModule",
      },
      {
        path: "chargetype",
        loadChildren:
          "../Masters/chargetype/chargetype.module#ChargeTypeModule",
      },
      {
        path: "chargemethod",
        loadChildren:
          "../Masters/chargemethod/chargemethod.module#ChargeMethodModule",
      },
      {
        path: "charges",
        loadChildren: "../Masters/charges/charges.module#ChargesModule",
      },
      {
        path: "MasterRateTemplate",
        loadChildren:
          "../Masters/master-rate-template/master-rate-template.module#MasterRateTemplateModule",
      },
      {
        path: "MasterRateProductTemplate",
        loadChildren:
          "../Masters/master-rate-template-product/master-rate-template-product.module#MasterRateTemplateProductModule",
      },
      {
        path: "Budget",
        loadChildren: "../Masters/budget/budget.module#BudgetModule",
      },
      {
        path: "uom",
        loadChildren: "../Masters/uom/uom.module#UomModule",
      },
      //add kevin 28/09/2021
      {
        path: "CityMaster",
        loadChildren:
          "../Masters/CityMaster/CityMaster.module#CityMasterModule",
      },
      //end
      //add vithujan 11-07-2022
      {
        path: "pincode-mapping",
        loadChildren:
          "../Masters/pincode-mapping/pincode-mapping.module#PincodeMappingModule",
      },
      //end
      {
        path: "RouteLocationMaster",
        loadChildren:
          "../Masters/RouteLocationMaster/RouteLocationMaster.module#RouteLocationMasterModule",
      },
      {
        path: "routeMaster",
        loadChildren: "../routeMaster/routeMaster.module#routeMasterModule",
      },
      {
        path: "MultiPointLaneConfig",
        loadChildren:
          "../Masters/MultiPointLaneConfig/MultiPointLaneConfig.module#MultiPointLaneConfigModule",
      },
      {
        path: "uomproduct",
        loadChildren:
          "../Masters/uomproduct-master/uomproduct-master.module#UOMProductMasterModule",
      },

      {
        path: "network/:Id", // 'path': 'network',
        loadChildren: "../Network/network/network.module#NetworkModule",
      },
      {
        path: "roles",
        loadChildren: "../roles/roles.module#RolesModule",
      },
      //added by vithujan 10-07-2023
      // {
      //   path: "trip-planning-map",
      //   loadChildren:
      //     "../trip-planning-map/trip-panning-map.module#TripPlanningMapModule",
      // },
      //end
      {
        path: "product",
        loadChildren: "../Products/product.module#ProductModule",
      },
      //added by vithujan 24-11-2022
      {
        path: "bosch-legal-entity-name",
        loadChildren:
          "../Masters/bosch-legal-entity-name/bosch-legal-entity-name.module#BoschLegalEntityNameModule",
      },
      {
        path: "bosch-business-division",
        loadChildren:
          "../Masters/bosch-business-division/bosch-business-division.module#BoschBusinessDivisionModule",
      },
      {
        path: "service-type",
        loadChildren:
          "../Masters/service-type/service-type.module#ServiceTypeModule",
      },
      //end

      // // ---------Map-------------------------------------

      // {
      //   path: "map",
      //   loadChildren: "../map/map.module#MapModule",
      // },

      //---------------------Quote-----------------------------------
      {
        path: "quote",
        loadChildren: "../Quotes/Quote/quote.module#QuoteModule",
      },
      {
        path: "vehiclePlanning",
        loadChildren:
          "../Quotes/vehicle-planning/vehicle-planning.module#VechiclePlanningModule",
      },
      //add trupti 24-feb-2022
      {
        path: "vehiclePlanningNew",
        loadChildren:
          "../Quotes/vehicle-planning-new/vehicle-planning-new.module#VechiclePlanningNewModule",
      },
      //end
      {
        path: "RouteOptimization",
        loadChildren:
          "../route-optimization/route-optimization.module#RouteOptimizationModule",
      },
      //---------------------bookings-----------------------------------

      {
        path: "mp_GateIn",
        loadChildren:
          "../Bookings/multiPickup/mp_GateIn/mp_GateIn.module#mp_GateInModule",
      },
      {
        path: "mp_PendingLR",
        loadChildren:
          "../Bookings/multiPickup/mp_PendingLR/mp_PendingLR.module#mp_PendingLRModule",
      },
      {
        path: "mp_OriginGateOut",
        loadChildren:
          "../Bookings/multiPickup/mp_OriginGateOut/mp_OriginGateOut.module#mp_OriginGateOutModule",
      },

      {
        path: "bookingdash",
        loadChildren:
          "../Bookings/dashboard/dashboard.module#BookingDashboardModule",
      },
      {
        path: "tripDocumentPrint",
        loadChildren:
          "../Bookings/TripDocumentPrint/TripDocumentPrint.module#TripDocumentPrintModule",
      },
      {
        path: "booking",
        loadChildren: "../Bookings/Booking/booking.module#BookingModule",
      },
      // add kevin 14/06/2021
      {
        path: "ECPickup",
        loadChildren:
          "../Bookings/Origin/ecPickup/ecPickup.module#ECPickupModule",
      },
      //end
      {
        path: "AssignedVehicle",
        loadChildren:
          "../Bookings/Origin/assigned-vehicle/assigned-vehicle.module#AssignedVehicleModule",
      },
      //add by maaria for eway pdf
      {
        path: "ewayPdf",
        loadChildren: "../Bookings/eway-pdf/eway-pdf.module#EwayPdfModule",
      },
      //end
      {
        path: "GateIn",
        loadChildren: "../Bookings/Origin/gate-in/gate-in.module#GateInModule",
      },
      {
        path: "Loaded",
        loadChildren:
          "../Bookings/Origin/vehicle-loaded/vehicle-loaded.module#VehicleLoadedModule",
      },
      {
        path: "ReadyToDispatch",
        loadChildren:
          "../Bookings/Origin/ready-to-dispatch/ready-to-dispatch.module#ReadyToDispatchModule",
      },
      {
        path: "Dispatched",
        loadChildren:
          "../Bookings/Origin/dispatched/dispatched.module#DispatchedModule",
      },
      {
        path: "eWayBill",
        loadChildren:
          "../Bookings/Origin/e-way-bill-ready/e-way-bill-ready.module#EWayBillReadyModule",
      },
      {
        path: "PendingArrival",
        loadChildren:
          "../Bookings/Destination/PendingArrival/PendingArrival.module#PendingArrivalModule",
      },
      {
        path: "DestinationGateIn",
        loadChildren:
          "../Bookings/Destination/destination-gate-in/destination-gate-in.module#DestinationGateInModule",
      },
      {
        path: "Unloaded",
        loadChildren:
          "../Bookings/Destination/vehicle-unloaded/vehicle-unloaded.module#VehicleUnloadedModule",
      },
      {
        path: "DeliveryConfirmed",
        loadChildren:
          "../Bookings/Destination/confirm-delivery/confirm-delivery.module#ConfirmDeliveryModule",
      },
      //added by vithujan 03-02-2023
      {
        path: "ReturnTrips",
        loadChildren:
          "../Bookings/Destination/return-trips/return-trips.module#ReturnTripsModule",
      },
      //end
      {
        path: "GateOut",
        loadChildren:
          "../Bookings/Destination/gate-out/gate-out.module#GateOutModule",
      },
      {
        path: "BookingCompleted",
        loadChildren:
          "../Bookings/Destination/booking-completed/booking-completed.module#BookingCompletedModule",
      },
      //---------------------Report-----------------------------------
      {
        path: "AccountReport",
        loadChildren:
          "../Reports/Accounts/account-report/account-report.module#AccountReportModule",
      },
      {
        path: "OutstandingReport/:From",
        loadChildren:
          "../Reports/Accounts/account-report/debitor-creditor-statement/debitor-creditor-statement.module#DebitorCreditorStatementModule",
      },
      {
        path: "TDSRegister/:From",
        loadChildren:
          "../Reports/Accounts/account-report/tdsregister/tdsregister.module#TDSRegisterModule",
      },
      {
        path: "tdsRegisterDetail/:From",
        loadChildren:
          "../Reports/Accounts/account-report/tdsRegisterDetail/tdsRegisterDetail.module#tdsRegisterDetailModule",
      },
      //Add Kevin 09/03/2020
      {
        path: "GST-Purchase",
        loadChildren:
          "../Reports/Accounts/account-report/gst-purchase/gstpurchase.module#gstpurchaseModule",
      },
      //Add manoj 17/03/2020
      {
        path: "PedingTripsBill",
        loadChildren:
          "../Reports/Accounts/account-report/pending-trips-for-bills/pending-trips-for-bills.module#PendingTripsForBillsModule",
      },
      //end
      {
        path: "GST-Register",
        loadChildren:
          "../Reports/Accounts/account-report/gst-register/gstregister.module#gstregisterModule",
      },
      //added by rahul
      {
        path: "BranchReport",
        loadChildren:
          "../Reports/Accounts/account-report/branch-report/branch-report.module#BranchReportModule",
      },
      {
        path: "ChargeReport",
        loadChildren:
          "../Reports/Accounts/account-report/chargeslist-report/chargeslist-report.module#ChargeslistReportModule",
      },
      {
        path: "ChartofaccountReport",
        loadChildren:
          "../Reports/Accounts/account-report/chartofaccount-report/chartofaccount-report.module#ChartofaccountReportModule",
      },
      {
        path: "CityMasterReport",
        loadChildren:
          "../Reports/Accounts/account-report/citymaster-report/citymaster-report.module#CitymasterReportModule",
      },
      {
        path: "customermasterReport",
        loadChildren:
          "../Reports/Accounts/account-report/customermaster-report/customermaster-report.module#CitymasterReportModule",
      },
      {
        path: "DriverMasterReport",
        loadChildren:
          "../Reports/Accounts/account-report/driver-master-report/driver-master-report.module#DriverMasterReportModule",
      },
      {
        path: "GstMasterReport",
        loadChildren:
          "../Reports/Accounts/account-report/gst-list-report/gst-list-report.module#GstListReporModule",
      },
      {
        path: "OpeningBalanceReport",
        loadChildren:
          "../Reports/Accounts/account-report/opening-balance-report/opening-balance-report.module#OpeningBalanceReportModule",
      },
      {
        path: "OrderlistReport",
        loadChildren:
          "../Reports/Accounts/account-report/orderlist-report/orderlist-report.module#OrderlistReportModule",
      },
      {
        path: "ProductlistReport",
        loadChildren:
          "../Reports/Accounts/account-report/productlist-report/productlist-report.module#ProductlistReportModule",
      },
      {
        path: "ServicereminderReport",
        loadChildren:
          "../Reports/Accounts/account-report/servicereminder-report/servicereminder-report.module#ServicereminderReportModule",
      },
      {
        path: "ReminderTypesReport",
        loadChildren:
          "../Reports/Accounts/account-report/reminder-types-report/reminder-types-report.module#ReminderTypesReportModule",
      },
      {
        path: "RepairsAndMaintenanceReport",
        loadChildren:
          "../Reports/Accounts/account-report/repaimaintainence-report/repaimaintainence-report.module#RepaimaintainenceReportModule",
      },
      {
        path: "TaxExemptionReport",
        loadChildren:
          "../Reports/Accounts/account-report/tax-exemption-report/tax-exemption-report.module#TaxExemptionReportModule",
      },
      {
        path: "ManageTDSReport",
        loadChildren:
          "../Reports/Accounts/account-report/manage-tds-report/manage-tds-report.module#ManageTDSReportModule",
      },
      {
        path: "TransportServiceReport",
        loadChildren:
          "../Reports/Accounts/account-report/transport-service-report/transport-service-report.module#TransportServiceReportModule",
      },
      {
        path: "TyrelistReport",
        loadChildren:
          "../Reports/Accounts/account-report/tyrelist-report/tyrelist-report.module#TyrelistReportModule",
      },
      {
        path: "VehicleListReport",
        loadChildren:
          "../Reports/Accounts/account-report/vehicle-list-report/vehicle-list-report.module#VehicleListReportModule",
      },
      {
        path: "UserListReport",
        loadChildren:
          "../Reports/Accounts/account-report/users-list-report/users-list-report.module#UsersListReportModule",
      },
      {
        path: "UserHierarchy",
        loadChildren:
          "../Reports/Operations/operational-report/userheirarchy/userheirarchy.module#UserHierarchyModule",
        //E:\iFreightBoxProduction\iFreightBox\iFreightBox\Angular\src\app\Reports\Operations\operational-report\userheirarchy\userheirarchy.component.html
      },
      {
        path: "VendorListReport",
        loadChildren:
          "../Reports/Accounts/account-report/vendor-list-report/vendor-list-report.module#VendorListReportModule",
      },

      {
        path: "TransporterListReport",
        loadChildren:
          "../Reports/Accounts/account-report/transporter-list-report/transporter-list-report.module#TransporterListReportModule",
      },
      {
        path: "voucherListReport",
        loadChildren:
          "../Reports/Accounts/account-report/voucher-list-report/voucher-list-report.module#VoucherListReportModule",
      },
      //end
      {
        path: "AgingReport/:From",
        loadChildren:
          "../Reports/Accounts/account-report/aging-report/aging-report.module#AgingReportModule",
      },
      {
        path: "JobProfitability/:From",
        loadChildren:
          "../Reports/Accounts/account-report/job-profitability/job-profitability.module#JobProfitabilityModule",
      },
      {
        path: "rp_JobProfiabilityReportOrderWise",
        loadChildren:
          "../Reports/Accounts/account-report/JobProfiabilityReportOrderWise/JobProfiabilityReportOrderWise.module#JobProfiabilityReportOrderWiseModule",
      },
      //added by sid start
      {
        path: "rp_dailystatusreport",
        loadChildren:
          "../Reports/Accounts/account-report/dailystatusreport/dailystatusreport.module#dailystatusreport",
      },

      // added by sid start
      {
        path: "SalesDetailsRegisterPivot",
        loadChildren:
          "../Reports/Accounts/account-report/sales-detail-register-pivot/sales-detail-register-pivot.module#SalesDetailRegisterPivotModule",
      },

      //added by sid end
      {
        path: "VehicleHistory",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-history/vehicle-history.module#VehicleHistoryModule",
      },
      {
        path: "DistanceTravelledReport",
        loadChildren:
          "../Reports/Operations/operational-report/distance-travelled/distance-travelled.module#DistanceTravelledModule",
      },
      {
        path: "TripStausReport",
        loadChildren:
          "../Reports/Operations/operational-report/trip-staus-report/trip-staus-report.module#TripStausReportModule",
      },
      //added by vithujan 19-10-2023 - Siddarth
      {
        path: "DeletedTransactions",
        loadChildren:
          "../Reports/Operations/operational-report/deleted-transactions/deleted-transactions.module#DeletedTransactionsModule",
      },
      //end
      {
        path: "TripStausSummaryReport",
        loadChildren:
          "../Reports/Operations/operational-report/tripstatussummaryreport/tripstatussummaryreport.module#TripstatussummaryreportModule",
      },
      {
        path: "TripCancelledReport",
        loadChildren:
          "../Reports/Operations/operational-report/trip-cancelled-report/trip-cancelled-report.module#TripCancelledReportModule",
      },
      {
        path: "OrderCancelledReport",
        loadChildren:
          "../Reports/Operations/operational-report/order-cancelled-report/order-cancelled-report.module#OrderCancelledReportModule",
      },
      {
        path: "TripAdvancePayment",
        loadChildren:
          "../Reports/Operations/operational-report/advance-payment-request-for-trips/advance-payment-request-for-trips.module#AdvancePaymentRequestForTripsModule",
      },
      {
        path: "Tyre-performance-report",
        loadChildren:
          "../Reports/Operations/operational-report/tyre-list-report/tyre-list-report.module#TyreListReportModule",
      },
      {
        path: "VehicleWiseMonthlyCalendar",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-wise-monthly-calendar/vehicle-wise-monthly-calendar.module#VehicleWiseMonthlyCalendarModule",
      },
      {
        path: "IndentByBranchAndByDeliveryCityReport",
        loadChildren:
          "../Reports/Operations/operational-report/indent-by-branch-and-by-delivery-city-report/indent-by-branch-and-by-delivery-city-report.module#IndentByBranchAndByDeliveryCityReportModule",
      },
      {
        path: "OriginGateReport",
        loadChildren:
          "../Reports/Operations/operational-report/origin-gate-register-report/origin-gate-register-report.module#OriginGateRegisterReportModule",
      },
      {
        path: "DestinationGateReport",
        loadChildren:
          "../Reports/Operations/operational-report/destination-gate-register-report/destination-gate-register-report.module#DestinationGateRegisterReportModule",
      },
      {
        path: "TripCountDataReport",
        loadChildren:
          "../Reports/Operations/operational-report/trip-count-data-report/trip-count-data-report.module#TripCountDataReportModule",
      },
      {
        path: "DailyOrderCountReport",
        loadChildren:
          "../Reports/Operations/operational-report/daily-order-count-report/daily-order-count-report.module#DailyOrderCountReportModule",
      },
      {
        path: "MonthlyOrderCountReport",
        loadChildren:
          "../Reports/Operations/operational-report/monthly-order-count-report/monthly-order-count-report.module#MonthlyOrderCountReportModule",
      },
      {
        path: "MonthlyOrdersCountByBrachAndCustomerReport",
        loadChildren:
          "../Reports/Operations/operational-report/monthly-orders-count-by-branch-and-customer-report/monthly-orders-count-by-branch-and-customer-report.module#MonthlyOrdersCountByBranchAndCustomerReportModule",
      },
      {
        path: "DailyOrderByCustomerTypeOfServicesReport",
        loadChildren:
          "../Reports/Operations/operational-report/daily-order-by-customer-type-of-services-report/daily-order-by-customer-type-of-services-report.module#DailyOrderByCustomerTypeOfServiceReportModule",
      },
      {
        path: "MonthlyOrderByCustomerTypeOfServicesReport",
        loadChildren:
          "../Reports/Operations/operational-report/monthly-order-by-customer-type-of-services-report/monthly-order-by-customer-type-of-services-report.module#MonthlyOrderByCustomerTypeOfServiceReportModule",
      },
      {
        path: "DailyOrdersCountByBrachAndCustomerReport",
        loadChildren:
          "../Reports/Operations/operational-report/daily-orders-count-by-branch-and-customer-report/daily-orders-count-by-branch-and-customer-report.module#DailyOrdersCountByBranchAndCustomerReportModule",
      },
      {
        path: "Tyre-history-report",
        loadChildren:
          "../Reports/Operations/operational-report/tyre-history-report/tyre-history-report.module#TyreHistoryReportModule",
      },

      {
        path: "OperationalReport",
        loadChildren:
          "../Reports/Operations/operational-report/operational-report.module#OperationalReportModule",
      },
      {
        path: "FinanceReport",
        loadChildren: "../Reports/finance/finance.module#FinanceModule",
      },
      {
        path: "TonnageReport/:From",
        loadChildren:
          "../Reports/Operations/operational-report/tonage-report/tonage-report.module#TonageReportModule",
      },
      {
        path: "VehicleDieselMileage",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-diesel-mileage/vehicle-diesel-mileage.module#VehicleDieselMileageModule",
      },
      {
        path: "Vechicle",
        loadChildren:
          "../Reports/Operations/operational-report/vechicle repairs and maintenance/vechicle.module#VechicleModule",
      },
      // added kevin for vehhicle summery report
      {
        path: "VehicleSummery",
        loadChildren:
          "../Reports/Operations/operational-report/VehicleSummery/VehicleSummery.module#VehicleSummeryModule",
      },
      {
        path: "BudgetReport",
        loadChildren:
          "../Reports/Operations/operational-report/budget-report/budget-report.module#BudgetReportModule",
      },
      {
        path: "VehicleAlertReport/:For",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-alert-report/vehicle-alert-report.module#VehicleAlertReportModule",
      },
      // add kevin 12/07/2021
      {
        path: "rp_LocationWiseDeliveryPoints",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseDeliveryPoints/LocationWiseDeliveryPoints.module#LocationWiseDeliveryPointsModule",
      },
      {
        path: "rp_LocationWiseShipToParties",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseShipToParties/LocationWiseShipToParties.module#LocationWiseShipToPartiesModule",
      },
      {
        path: "rp_LocationWiseInvoicesade",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseInvoicesmade/LocationWiseInvoicesmade.module#LocationWiseInvoicesmadeModule",
      },
      {
        path: "rp_LocationWiseBoxesHandled",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseBoxesHandled/LocationWiseBoxesHandled.module#LocationWiseBoxesHandledModule",
      },
      {
        path: "rp_LocationWiseKMCovered",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseKMCovered/LocationWiseKMCovered.module#LocationWiseKMCoveredModule",
      },
      {
        path: "rp_LocationWiseTransporters",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseTransporters/LocationWiseTransporters.module#LocationWiseTransportersModule",
      },
      {
        path: "rp_LocationWiseVehiclesUsed",
        loadChildren:
          "../Reports/Operations/operational-report/LocationWiseVehiclesUsed/LocationWiseVehiclesUsed.module#LocationWiseVehiclesUsedModule",
      },
      // end
      // add kevin 25-Jan-2022
      {
        path: "rp_ImportDispatch",
        loadChildren:
          "../Reports/Operations/operational-report/ImportDispathReport/ImportDispathReport.module#ImportDispathReportModule",
      },
      {
        path: "rp_ImportJobCompletion",
        loadChildren:
          "../Reports/Operations/operational-report/ImportJobCompletionReport/ImportJobCompletionReport.module#ImportJobCompletionReportModule",
      },
      {
        path: "rp_ExportDispatch",
        loadChildren:
          "../Reports/Operations/operational-report/ExportDispatchReport/ExportDispatchReport.module#ExportDispatchReportModule",
      },
      {
        path: "rp_ExportJobComplition",
        loadChildren:
          "../Reports/Operations/operational-report/ExportJobComplitionReport/ExportJobComplitionReport.module#ExportJobComplitionReportModule",
      },
      {
        path: "rp_SimTracking",
        loadChildren:
          "../Reports/Operations/operational-report/SimTrackingReport/SimTrackingReport.module#SimTrackingReportModule",
      },
      {
        path: "VehicleLoadUtilizationByTrip",
        loadChildren:
          "../Reports/Operations/operational-report/vehicleloadutilizationbytrip/vehicleloadutilizationbytrip.module#VehicleLoadUtilizationByTripModule",
      },
      {
        path: "AllocatedDriveIdleTime",
        loadChildren:
          "../Reports/Operations/operational-report/allocated-driver-idle-time/allocated-driver-idle-time.module#AllocatedDriverIdleTimeModule",
      },
      {
        path: "ot_DispatchReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_DispatchReport/ot_DispatchReport.module#ot_DispatchReportModule",
      },

      {
        path: "DispatchReport",
        loadChildren:
          "../Reports/Operations/operational-report/dispatchreportlist/dispatchreportlist.module#DispatchReportListModule",
      },

      {
        path: "ot_PendingDispatchReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_PendingDispatchReport/ot_PendingDispatchReport.module#ot_PendingDispatchReportModule",
      },
      {
        path: "ot_DEPSReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_DEPSReport/ot_DEPSReport.module#ot_DEPSReportModule",
      },
      {
        path: "ot_ReceivedScannedReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_ReceivedScannedReport/ot_ReceivedScannedReport.module#ot_ReceivedScannedReportModule",
      },
      {
        path: "ot_DestinationScannedReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_DestinationScannedReport/ot_DestinationScannedReport.module#ot_DestinationScannedReportModule",
      },
      {
        path: "ot_materReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_materReport/ot_materReport.module#ot_materReportModule",
      },
      {
        path: "ot_ShipmentTrackingReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_ShipmentTrackingReport/ot_ShipmentTrackingReport.module#ot_ShipmentTrackingReportModule",
      },
      {
        path: "ot_vehicleDispatchPerformanceReport",
        loadChildren:
          "../Reports/Operations/operational-report/ot_vehicleDispatchPerformanceReport/ot_vehicleDispatchPerformanceReport.module#ot_vehicleDispatchPerformanceReportModule",
      },
      {
        path: "opa_BagHistoryReport",
        loadChildren:
          "../Reports/Operations/operational-report/opa_BagHistoryReport/opa_BagHistoryReport.module#opa_BagHistoryReportModule",
      },
      {
        path: "opa_BagInventoryReport",
        loadChildren:
          "../Reports/Operations/operational-report/opa_BagInventoryReport/opa_BagInventoryReport.module#opa_BagInventoryReportModule",
      },
      {
        path: "opa_TamperedBagReport",
        loadChildren:
          "../Reports/Operations/operational-report/opa_TamperedBagReport/opa_TamperedBagReport.module#opa_TamperedBagReportModule",
      },
      {
        path: "lm_collectionReconciliation",
        loadChildren:
          "../Reports/Operations/operational-report/lm_collectionReconciliation/lm_collectionReconciliation.module#lm_collectionReconciliationModule",
      },
      {
        path: "lm_OrdersSummaryReport",
        loadChildren:
          "../Reports/Operations/operational-report/lm_OrdersSummaryReport/lm_OrdersSummaryReport.module#lm_OrdersSummaryReportModule",
      },
      //added by rahul
      {
        path: "ot_orderwiseincomeexpense",
        loadChildren:
          "../Reports/Operations/operational-report/ot-orderwiseincomeexpense/ot-orderwiseincomeexpense.module#otorderwiseincomeexpenseModule",
      },
      //added by vithu 09-09-2024
      {
        path: "vehicle-destination-performance",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-destination-performance/vehicle-destination-performance.module#VehicleDestinationPerformanceModule",
      },
      {
        path: "vehicle-origin-performance",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-origin-performance/vehicle-origin-performance.module#VehicleOriginPerformanceModule",
      },
      {
        path: "vehicle-loading-performance",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-loading-performance/vehicle-loading-performance.module#VehicleLoadingPerformanceModule",
      },
      {
        path: "vehicle-utilization",
        loadChildren:
          "../Reports/Operations/operational-report/vehicle-utilization/vehicle-utilization.module#VehicleUtilizationModule",
      },
      {
        path: "pending-trip",
        loadChildren:
          "../Reports/Operations/operational-report/pending-trip/pending-trip.module#PendingTripModule",
      },
      {
        path: "daily-trip-delivery-performance",
        loadChildren:
          "../Reports/Operations/operational-report/daily-trip-delivery-performance/daily-trip-delivery-performance.module#DailyTripDeliveryPerformanceModule",
      },
      ///added by sid - 31-05-2024
      {
        path: "UserActivityLog",
        loadChildren:
          "../Reports/Operations/operational-report/activitylog/activitylog.module#ActivitylogModule",
      },
      {
        path: "UserActivityLogAccounts",
        loadChildren:
          "../Reports/Operations/operational-report/activitylogaccounts/activitylogaccounts.module#Activitylogaccountsmodule",
      },
      {
        path: "UserActivityLogMasters",
        loadChildren:
          "../Reports/Operations/operational-report/activitylogmasters/activitylogmasters.module#ActivityLogMastersModule",
      },

      //addded by sid end

      ///added by sid - 10-06-2024
      {
        path: "BiddingReport",
        loadChildren:
          "../Reports/Operations/operational-report/bidding-rp/bidding-rp.module#BiddingRpModule",
      },
      {
        path: "FrequentCollectionDelay",
        loadChildren:
          "../Reports/Operations/operational-report/frequentcollectiondelay/frequentcollectiondelay.module#FrequentCollectionDelayModule",
      },
      {
        path: "SalesReturnReport",
        loadChildren:
          "../Reports/Operations/operational-report/sales-return-report/sales-return-report.module#SalesReturnReportModule",
      },

      {
        path: "DriverNetSalesReport",
        loadChildren:
          "../Reports/Operations/operational-report/driver-net-sales/driver-net-sales.module#DriverNetSalesModule",
      },
      ///added by sid end- 10-06-2024
      {
        path: "ot_TripStatusByTripExpense",
        loadChildren:
          "../Reports/Operations/operational-report/trip-status-by-trip-expense/trip-status-by-trip-expense.module#TripStatusByTripExpenseModule",
      },
      {
        path: "trip_IncomeExpenseChargeWiseReport",
        loadChildren:
          "../Reports/Operations/operational-report/trip_IncomeExpenseChargeWiseReport/trip_IncomeExpenseChargeWiseReport.module#trip_IncomeExpenseChargeWiseReportModule",
      },
      {
        path: "Trip_IncomeExpenseWithPaymentReport",
        loadChildren:
          "../Reports/Operations/operational-report/Trip_IncomeExpenseWithPaymentReport/Trip_IncomeExpenseWithPaymentReport.module#Trip_IncomeExpenseWithPaymentReportModule",
      },
      {
        path: "rp_TripWiseIncomeExpense",
        loadChildren:
          "../Reports/Operations/operational-report/trip-wise-income-expense/trip-wise-income-expense.module#TripWiseIncomeExpenseModule",
      },
      {
        path: "rp_LrWiseIncomeExpense",
        loadChildren:
          "../Reports/Operations/operational-report/lrwise-income-expense/lrwise-income-expense.module#LrwiseincomeexpenseModule",
      },
      // {
      //   path: "Internet",
      //   loadChildren:
      //     "../Reports/Operations/operational-report/internet-connectivity/internet-connectivity.module#InternetConnectivityModule",
      // },
      //end
      // end
      {
        path: "RoleRights",
        loadChildren: "../role-rights/role-rights.module#RoleRightsModule",
      },
      {
        path: "SalesRegister",
        loadChildren:
          "../Reports/Accounts/account-report/sales-register/sales-register.module#SalesRegisterModule",
      },
      {
        path: "SalesDetailsRegister",
        loadChildren:
          "../Reports/Accounts/account-report/sales-details-register/sales-details-register.module#SalesDetailsRegisterModule",
      },
      {
        path: "PurchaseDetailsRegister",
        loadChildren:
          "../Reports/Accounts/account-report/purchase-details-register/purchase-details-register.module#PurchaseDetailsRegisterModule",
      },
      {
        path: "ReceiptRegister",
        loadChildren:
          "../Reports/Accounts/account-report/receipt-register/receipt-register.module#ReceiptRegisterModule",
      },
      {
        path: "PurchaseRegister",
        loadChildren:
          "../Reports/Accounts/account-report/purchase-register/purchase-register.module#PurchaseRegisterModule",
      },
      {
        path: "PaymentRegister",
        loadChildren:
          "../Reports/Accounts/account-report/payment-register/payment-register.module#PaymentRegisterModule",
      },
      {
        path: "ExpenseRegister",
        loadChildren:
          "../Reports/Accounts/account-report/expense-register/expense-register.module#ExpenseRegisterModule",
      },
      //add kevin 30/04/2021
      {
        path: "MasterHouseCostBreakUp",
        loadChildren:
          "../Reports/Accounts/account-report/MasterHouseCostBreakUp/MasterHouseCostBreakUp.module#MasterHouseCostBreakUpModule",
      },
      {
        path: "MasterHouseCostBreakUp_byCustomer",
        loadChildren:
          "../Reports/Accounts/account-report/MasterHouseCostBreakUp_byCustomer/MasterHouseCostBreakUp_byCustomer.module#MasterHouseCostBreakUp_byCustomerModule",
      },
      {
        path: "MasterHouseCostBreakUp_byBranch",
        loadChildren:
          "../Reports/Accounts/account-report/MasterHouseCostBreakUp_byBranch/MasterHouseCostBreakUp_byBranch.module#MasterHouseCostBreakUp_byBranchModule",
      },
      {
        path: "MasterHouseCostBreakUp_byVehicleType",
        loadChildren:
          "../Reports/Accounts/account-report/MasterHouseCostBreakUp_byVehicleType/MasterHouseCostBreakUp_byVehicleType.module#MasterHouseCostBreakUp_byVehicleTypeModule",
      },
      {
        path: "MasterHouseCostBreakUp_byTransporter",
        loadChildren:
          "../Reports/Accounts/account-report/MasterHouseCostBreakUp_byTransporter/MasterHouseCostBreakUp_byTransporter.module#MasterHouseCostBreakUp_byTransporterModule",
      },
      //end

      {
        path: "ReminderService",
        loadChildren: "../Reminders/service/service.module#ServiceModule",
      },
      {
        path: "ReminderRenewal",
        loadChildren: "../Reminders/renewal/renewal.module#RenewalModule",
      },
      {
        path: "ReminderTaskType",
        loadChildren: "../Reminders/task-type/task-type.module#TaskTypeModule",
      },
      // --------------------- Fleet-----------------------------------
      {
        path: "Driver/:Id", //'path': 'Driver',
        loadChildren: "../Fleet/driver/driver.module#DriverModule",
      },
      // {
      //   path: "NewDriver", //'path': 'Driver',
      //   loadChildren: "../Fleet/new-driver/new-driver.module#NewDriverModule",
      // },
      // {
      //   path: "Driver/:Id", //'path': 'Driver',
      //   loadChildren: "../Fleet/new-driver/new-driver.module#NewDriverModule",
      // },
      // {
      //   path: "Driver/list/view/:id",
      //   // component: DriverDetailsByIdComponent,
      //   loadChildren:
      //     "../Fleet/new-driver/driver-details-by-id/driver-details-by-id-view-shared.module#DriverDetailsByIdViewSharedModule"
      // },
      // {
      //   path: "Driver/list/edit/:id",
      //   loadChildren:
      //     "../Fleet/new-driver/driver-details-by-id/driver-details-by-id-edit/driver-details-by-id-edit-shared.module#DriverDetailsByIdEditSharedModule"
      //   // component: DriverDetailsByIdEditComponent,
      // },
      {
        path: "VehicleMaster",
        loadChildren:
          "../Fleet/vehicle-master/vehicle-master.module#VehicleMasterModule",
      },
      // {
      //   path: "VehicleTracking",
      //   loadChildren:
      //     "../Fleet/vehicle-tracking/vehicle-tracking.module#VehicleTrackingModule",
      // },
      //add pratiksha 04-10-23
      // {
      //   path: "NewVehicleMaster",
      //   loadChildren:
      //     "../Fleet/new-vehicle-master/vehicle-list.module#VehicleListModule",
      // },
      //add trupti 13-dec-2021
      {
        path: "VehicleInspection",
        loadChildren:
          "../Fleet/vehicle-inspection/vehicle-inspection.module#VehicleInspectionModule",
      },
      //end
      {
        path: "TyreList",
        loadChildren:
          "../Fleet/Tyres/tyres-list/tyres-list.module#TyresListModule",
      },
      {
        path: "TyreReatreading",
        loadChildren:
          "../Fleet/Tyres/tyres-reatreading/tyres-reatreading.module#TyresReatreadingModule",
      },

      {
        path: "TyreRepair",
        loadChildren:
          "../Fleet/Tyres/tyres-repair/tyres-repair.module#TyresRepairModule",
      },

      {
        path: "TyreAssign",
        loadChildren:
          "../Fleet/Tyres/tyres-assign/tyres-assign.module#TyresAssignModule",
      },

      {
        path: "TyreDiscard",
        loadChildren:
          "../Fleet/Tyres/tyres-discard/tyres-discard.module#TyresDiscardModule",
      },
      {
        path: "documents",
        loadChildren: "../documents/documents.module#DocumentsModule",
      },

      {
        path: "issues",
        loadChildren: "../Fleet/issues/issues.module#IssuesModule",
      },
      {
        path: "LiveVehicleTracking",
        loadChildren:
          "../Fleet/live-vehicle-tracking/live-vehicle-tracking.module#LiveVehicleTrackingModule",
      },

      //---------------------Purchase-----------------------------------
      {
        path: "Bills",
        loadChildren: "../Purchase/bills/bills.module#BillsModule",
      },
      //added by vithujan 20-02-2024
      {
        path: "AdvancePayment",
        loadChildren:
          "../Purchase/advance-payment/advance-payment.module#AdvancePaymentModule",
      },
      // end
      {
        path: "PaymentMode_Approval",
        loadChildren:
          "../Purchase/PaymentMode_Approval/PaymentMode_Approval.module#PaymentMode_ApprovalModule",
      },
      //add vithujan 17-06-2022
      {
        path: "PendingBills",
        loadChildren:
          "../Purchase/pending-bills/pending-bills.module#PendingBillsModule",
      },
      {
        path: "Requisitions",
        loadChildren:
          "../Purchase/requisitions/requisitions.module#RequisitionsModule",
      },
      {
        path: "Expense",
        loadChildren: "../Purchase/expense/expense.module#ExpenseModule",
      },
      {
        path: "PaymentMade/:Id",
        loadChildren:
          "../Purchase/payment-made/payment-made.module#PaymentMadeModule",
      },
      {
        path: "PaymentRequest",
        loadChildren:
          "../Purchase/payment-request/payment-request.module#PaymentRequestModule",
      },
      {
        path: "SchedulePayment",
        loadChildren:
          "../Purchase/schedule-payment/schedule-payment.module#SchedulePaymentModule",
      },
      //---------------------Accounting-----------------------------------

      {
        path: "account-dashboard",
        loadChildren:
          "../Accouting/account-dashboard/account-dashboard.module#AccountDashboardModule",
      },
      {
        path: "ChartOfAccounts",
        loadChildren:
          "../Accouting/chart-of-accounts/chart-of-accounts.module#ChartOfAccountsModule",
      },
      {
        path: "BankAccounts",
        loadChildren:
          "../Accouting/bank-accounts/bank-accounts.module#BankAccountsModule",
      },

      {
        path: "JournalEntry",
        loadChildren:
          "../Accouting/journal-entry/journal-entry.module#JournalEntryModule",
      },
      // {
      //   path: "new-journal-entry",
      //   loadChildren:
      //     "../Accouting/new-journal-entry/new-journal-entry.module#NewJournalEntryModule",
      // },
      {
        path: "OpeningBalance",
        loadChildren:
          "../Accouting/opening-balance/opening-balance.module#OpeningBalanceModule",
      },
      {
        path: "Ledgers",
        loadChildren: "../Accouting/ledgers/ledgers.module#LedgersModule",
      },
      {
        path: "managetaxes",
        loadChildren:
          "../Accouting/manage-taxes/manage-taxes.module#ManageTaxesModule",
      },
      {
        path: "defaulttaxpreference",
        loadChildren:
          "../Accouting/default-tax-preference/default-tax-preference.module#DefaultTaxPreferenceModule",
      },
      {
        path: "TaxExemptionsModule",
        loadChildren:
          "../Accouting/tax-exemptions/tax-exemptions.module#TaxExemptionsModule",
      },
      {
        path: "managetds",
        loadChildren:
          "../Accouting/manage-tds/manage-tds.module#ManageTdsModule",
      },
      {
        path: "Invoice",
        loadChildren:
          "../invoice-numbering/invoice-numbering.module#InvoiceNumberingModule",
      },
      //added by vithujan 14-09-2022
      {
        path: "EmailConfiguration",
        loadChildren:
          "../EmailConfiguration/EmailConfiguration.module#EmailConfigurationModule",
      },
      //end
      {
        path: "TrialBalance",
        loadChildren:
          "../Accouting/trial-balance/trial-balance.module#TrialBalanceModule",
      },
      {
        path: "GeneralLedger",
        loadChildren:
          "../Accouting/general-ledger/general-ledger.module#GeneralLedgerModule",
      },
      //add vithujan 04-08-2022
      {
        path: "SalesRegisterMultipoint",
        loadChildren:
          "../Reports/Accounts/account-report/sales-register-ksh/sales-register-ksh.module#SalesRegisterKSHModule",
      },

      //addded by sid 17-06-2024
      {
        path: "PaymentExceptions",
        loadChildren:
          "../Reports/Accounts/account-report/payment-exceptions/payment-exceptions.module#PaymentExceptionsModule",
      },
      //addded by sid end 17-06-2024
      //added by sid on 28-06-2024
      {
        path: "SAPsentReport",
        loadChildren:
          "../Reports/Operations/operational-report/sapsentreport/sapsentreport.component.module#SAPsentreportModule",
      },
      {
        path: "CustomerBalanceByTrip",
        loadChildren:
          "../Reports/Operations/operational-report/customer-balancebytrip/customerbalancebytrip.module#CustomerBalancebytripModule",
      },
      {
        path: "CustomerBalance",
        loadChildren:
          "../Reports/Operations/operational-report/customerbalance/customerbalance.module#CustomerBalanceModule",
      },

      {
        path: "OrderListTripWise",
        loadChildren:
          "../Reports/Operations/operational-report/orderlisttripwise/orderlisttripwise.module#OrderListTripWiseModule",
      },

      {
        path: "OrderIntegrationLog",
        loadChildren:
          "../Reports/Operations/operational-report/order-integration-log/OrderIntegrationlog.module#OrderIntegrationLogModule",
      },

      //end
      //add vithujan 06-12-2022
      {
        path: "CashReceiptReport",
        loadChildren:
          "../Reports/Accounts/account-report/cash-receipt-report/cash-receipt-report.module#CashReceiptModuleModule",
      },
      //end
      {
        path: "BankAccount",
        loadChildren:
          "../Reports/Accounts/account-report/BankAccount/BankAccount.module#BankAccountModule",
      },
      //added by vithujan 06-03-2023 - Widdarth
      {
        path: "TripProfitability",
        loadChildren:
          "../Reports/Accounts/account-report/trip-profitability/trip-profitability.module#TripProfitabilityModule",
      },
      // end
      //added by Rahul - Widdarth
      {
        path: "GLAccount",
        loadChildren:
          "../Reports/Accounts/account-report/gl-account-report/gl-account-report.module#GLAccountReportModule",
      },
      // end
      {
        path: "CardAccount",
        loadChildren:
          "../Reports/Accounts/account-report/CardAccount/CardAccount.module#CardAccountModule",
      },
      {
        path: "CashAccount",
        loadChildren:
          "../Reports/Accounts/account-report/CashAccount/CashAccount.module#CashAccountModule",
      },

      {
        path: "ProfitandLoss",
        loadChildren:
          "../Accouting/profitand-loss/profitand-loss.module#ProfitandLossModule",
      },
      {
        path: "BalanceSheet",
        loadChildren:
          "../Accouting/balance-sheet/balance-sheet.module#BalanceSheetModule",
      },
      {
        path: "BankReconcilation",
        loadChildren:
          "../Accouting/bank-reconcilation/bank-reconcilation.module#BankReconcilationModule",
      },
      {
        path: "AccountingPeriod",
        loadChildren:
          "../Accouting/AccountingPeriod/AccountingPeriod.module#AccountingPeriodModule",
      },
      {
        path: "BankStatement",
        loadChildren:
          "../Accouting/BankStatement/BankStatement.module#BankStatementModule",
      },

      //---------------------Orders-----------------------------------
      {
        path: "order",
        loadChildren: "../Orders/order.module#OrderModule",
      },
      {
        path: "By-Courier",
        loadChildren: "../Orders/ByCourier/ByCourier.module#ByCourierModule",
      },
      {
        path: "Courier-Plan-Shipment",
        loadChildren:
          "../Orders/courier-plan-shipment/courier-plan-shipment.module#CourierPlanShipmentModule",
      },
      {
        path: "ByLoad",
        loadChildren: "../Orders/by-load/load.module#ByLoadModule",
      },

      {
        path: "ByVehicle",
        loadChildren: "../Orders/by-vehicle/by-vehicle.module#ByVehicleModule",
      },

      {
        path: "ByCustomer",
        loadChildren:
          "../Orders/by-customer/by-customer.module#ByCustomerModule",
      },

      //----------------------Sales------------------------------------
      {
        path: "PendingConsignments",
        loadChildren:
          "../Sales/pending-consignment/pending-consignment.module#PendingConsignmentModule",
      },
      {
        path: "SalesInvoice",
        loadChildren:
          "../Sales/sales-invoice/sales-invoice.module#SalesInvoiceModule",
      },
      //added by vithujan 06-02-2024 - Siddarth
      {
        path: "PaymentRequestSales",
        loadChildren:
          "../Sales/payment-request-sales/payment-request-sales.module#PaymentRequestSalesModule",
      },
      //end

      // {
      //   path: "PaymentReceived/:Id",
      //   loadChildren:
      //     "../Sales/payment-received/payment-received.module#PaymentReceivedModule",
      // },
      {
        path: "PaymentReceived",
        loadChildren:
          "../Sales/payment-received/payment-received.module#PaymentReceivedModule",
      },
      {
        path: "CashReceipt",
        loadChildren:
          "../Sales/CashReceipt/CashReceipt.module#CashReceiptModule",
      },
      {
        path: "DangerousGoods",
        loadChildren:
          "../dangerous-goods/dangerous-goods.module#DangerousGoodsModule",
      },

      {
        path: "FuelPump",
        loadChildren: "../FuelPump/FuelPump.module#FuelPumpModule",
      },
      //------------------ViewInvoice----------------------------------

      //---------------------Warehouse-----------------------------------
      {
        path: "WarehouseSettings",
        loadChildren:
          "../Warehouse/warehousesettings/warehousesettings.module#WarehouseSettingsModule",
      },
      {
        path: "inwards",
        loadChildren: "../Warehouse/inwards/inwards.module#InwardsModule",
      },
      {
        path: "outwards",
        loadChildren: "../Warehouse/outwards/outwards.module#OutwardsModule",
      },
      {
        path: "dimensionmaster",
        loadChildren:
          "../Warehouse/dimension-master/dimension-master.module#DimensionMasterModule",
      },
      {
        path: "locationrestriction",
        loadChildren:
          "../Warehouse/locationrestriction/locationrestriction.module#LocationrestrictionModule",
      },
      {
        path: "warehousemaster",
        loadChildren:
          "../Warehouse/warehousemaster/warehousemaster.module#WarehousemasterModule",
      },
      {
        path: "managelocation/:WarehouseID",
        loadChildren:
          "../Warehouse/managelocation/managelocation.module#ManagelocationModule",
      },
      {
        path: "locationhierarchy/:WarehouseID",
        loadChildren:
          "../Warehouse/managelocation/locationhierarchy/locationhierarchy.module#LocationhierarchyModule",
      },
      {
        path: "generatelocations/:WarehouseID",
        loadChildren:
          "../Warehouse/managelocation/generatelocations/generatelocations.module#GenerateLocationsModule",
      },
      {
        path: "generatelocationlist/:WarehouseID",
        loadChildren:
          "../Warehouse/managelocation/generatelocationlist/generatelocationlist.module#GeneratelocationlistModule",
      },
      {
        path: "warehouslablescriptmaster",
        loadChildren:
          "../Warehouse/Printscript-master/Printscript-master.module#PrintScriptMasterModule",
      },
      {
        path: "wh_reports",
        loadChildren:
          "../Warehouse/Wharehouse_Reports/wh_reports.module#WHReportsModule",
      },
      {
        path: "wh_StockReport",
        loadChildren:
          "../Warehouse/Wharehouse_Reports/wh_StockReport/wh_StockReport.module#wh_StockReportModule",
      },
      {
        path: "wh_InwardRegister",
        loadChildren:
          "../Warehouse/Wharehouse_Reports/wh_InwardRegister/wh_InwardRegister.module#wh_InwardRegisterModule",
      },
      {
        path: "wh_OutwardRegister",
        loadChildren:
          "../Warehouse/Wharehouse_Reports/wh_OutwardRegister/wh_OutwardRegister.module#wh_OutwardRegisterModule",
      },
      {
        path: "wh_Damage_Shortage_HoldReport",
        loadChildren:
          "../Warehouse/Wharehouse_Reports/wh_Damage_Shortage_HoldReport/wh_Damage_Shortage_HoldReport.module#wh_Damage_Shortage_HoldReportModule",
      },
      {
        path: "Waypoints",
        loadChildren: "../map/WaypointsMap/Waypoints.module#WaypointsMapModule",
      },
      //add trupti 20-jan-2022
      {
        path: "pending-trips-for-invoicing",
        loadChildren:
          "../Reports/Accounts/account-report/pending-trips-for-invoicing/pending-trips-for-invoicing.module#PendingTripsForInvoicingModule",
      },
      //end
      //add vithujan 11-06-2022
      {
        path: "DailyOperational",
        loadChildren:
          "../Reports/Operations/operational-report/daily-operational-report/daily-operational-report.module#DailyOperationalReportModule",
      },
      //end
      //added by vithujan 20-11-2023 - Siddarth
      {
        path: "DailyOperationalDetail",
        loadChildren:
          "../Reports/Operations/operational-report/daily-operational-report-detail/daily-operational-report-detail.module#DailyOperationalReportDetailModule",
      },
      //end
      //add vithujan 01-08-2022
      {
        path: "CustomerRateCheckHistory",
        loadChildren:
          "../Reports/Operations/operational-report/customer-ratecheck-history/customer-ratecheck-history.module#CustomerRateCheckHistoryReportModule",
      },
      //end
      {
        path: "cashBook",
        loadChildren:
          "../Reports/Operations/operational-report/cashBook/cashBook.module#cashBookModule",
      },
      {
        path: "dailyTripStatus",
        loadChildren:
          "../Reports/Operations/operational-report/dailyTripStatus/dailyTripStatus.module#DailyTripStautsModule",
      },
      //added by vithujan 09-08-2024
      {
        path: "DailyTrips",
        loadChildren:
          "../Reports/Operations/operational-report/daily-trips-report/daily-trips-report.module#DailyTripReportModule",
      },
      //End
      // Added by Thanu 29-08-2024
      {
        path: "JSONGenerator",
        loadChildren:
          "../Reports/Operations/operational-report/jsongenerator/jsongenerator.module#JSONGeneratorModule",
      },
      //end
      {
        path: "TimeWindowMaster",
        loadChildren:
          "../Masters/TimeWindowMaster/TimeWindowMaster.module#TimeWindowMasterModule",
      },
      {
        path: "cpm_couponMaster",
        loadChildren:
          "../Masters/couponMaster/couponMaster.module#couponMasterModule",
      },
      //add by maaria
      {
        path: "payment-gateway",
        loadChildren:
          "../Masters/payment-gateway/payment-gateway.module#PaymentGatewayModule",
      },
      {
        path: "google-pay",
        loadChildren: "../Masters/google-pay/google-pay.module#GooglePayModule",
      },
    ],
  },
  //Pratiksha 06-11-23
  {
    path: "",
    component: NewDesignLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "index2", //'path': 'index2',
        loadChildren: "../new-default/default.module#DefaultModule",
      },

      {
        path: "NewBeat", //'path': 'newbeat',
        loadChildren: "../beats/new-beat/new-beat.module#newbeatModule",
      },
      {
        path: "NewTyreDiscard", //'path': 'NewTyreDiscard',
        loadChildren:
          "../Fleet/NewTyres/NewTyres-discard/newtyres-discard.module#NewTyresdiscardModule",
      },
      {
        path: "NewTyreAssign", //'path': 'NewTyreAssign',
        loadChildren:
          "../Fleet/NewTyres/new-tyresassign/new-tyresassign.module#NewTyresassignModule",
      },
      {
        path: "NewTyreRepair", //'path': 'NewTyreRepair',
        loadChildren:
          "../Fleet/NewTyres/newtyres-repair/newtyres-repair.module#NewtyresRepairModule",
      },
      {
        path: "NewTyreRetreading", //'path': 'NewTyreRepair',
        loadChildren:
          "../Fleet/NewTyres/newtyresretreading/newtyresretreading.module#NewtyresRetreadingModule",
      },
      {
        path: "NewTyreList", //'path': 'NewTyreRepair',
        loadChildren:
          "../Fleet/NewTyres/newtyres-list/newtyres-list.module#NewtyresListModule",
      },
      {
        path: "NewDriver", //'path': 'Driver',
        loadChildren: "../Fleet/new-driver/new-driver.module#NewDriverModule",
      },
      {
        path: "NewVehicleMaster",
        loadChildren:
          "../Fleet/new-vehicle-master/vehicle-list.module#VehicleListModule",
      },
      {
        path: "NewCompany",
        loadChildren:
          "../Masters/new-company/company-list.module#companyListModule",
      },
      {
        path: "NewSettings",
        loadChildren:
          "../Masters/new-settings/new-settings.module#NewSettingsModule",
      },
      {
        path: "NewRoleRights",
        loadChildren:
          "../role-access-rights/role-access-rights.module#RoleAccessRightModule",
      },
      {
        path: "NewInvoice",
        loadChildren:
          "../theme/transporter-app/new-invoice/new-invoice-list.module#InvoiceListModule",
      },
      {
        path: "NewUser",
        loadChildren: "../Masters/new-user/new-user-list.module#userListModule",
      },
      {
        path: "NewManageTaxes",
        loadChildren:
          "../Accouting/new-manage-taxes/new-manage-taxes-list.module#NewManageTaxesModule",
      },
      {
        path: "NewManageCess",
        loadChildren:
          "../Accouting/new-manage-cess/new-manage-cess.module#NewManageCessModule",
      },
      {
        path: "NewNetwork", //'path': 'index2',
        loadChildren: "../new-network/new-network.module#NewNetworkModule",
      },
      {
        path: "so_Orders", //'path': 'index2',
        loadChildren:
          "../newDesign/new-orders/new-orders.module#NewOrdersModule",
      },
      {
        path: "so_ReturnOrder", //'path': 'index2',
        loadChildren:
          "../newDesign/so_ReturnOrder/so_ReturnOrder.module#so_ReturnOrderModule",
      },
      {
        path: "so_StockTransfer", //'path': 'index2',
        loadChildren:
          "../newDesign/so_StockTransfer/so_StockTransfer.module#so_StockTransferModule",
      },
      {
        path: "NewSalesOrder",
        loadChildren:
          "../newDesign/newsales-order/newsales-order.module#NewSalesOrderModule",
      },
      //add by maaria on 31-10-2023
      {
        path: "NewShipmentmode",
        loadChildren:
          "../Masters/new-shipmentmode/shipmentmode.module#ShipmentmodeModule",
      },
      {
        path: "NewTransportservice",
        loadChildren:
          "../Masters/new-transportservices/transportservices.module#TransportservicesModule",
      },
      {
        path: "NewChartOfAccounts",
        loadChildren:
          "../Accouting/new-chart-of-accounts/new-chart-of-accounts.module#NewChartOfAccountsModule",
      },

      //end
      // Add more routes for the secondary layout
      //added by vithujan 27-10-2023 - Siddarth
      {
        path: "roles-new",
        loadChildren: "../roles-new/roles-new.module#RolesNewModule",
      },
      {
        path: "business-new",
        loadChildren:
          "../Masters/business-new/business-new.module#BusinessNewModule",
      },
      {
        path: "uom-new",
        loadChildren: "../Masters/uom-new/uom-new.module#UomNewModule",
      },
      {
        path: "new-countries",
        loadChildren: "../Masters/country/country.module#CountryModule",
      },
      {
        path: "new-state",
        loadChildren: "../Masters/state/state.module#StateModule",
      },
      {
        path: "new-city",
        loadChildren:
          "../Masters/new-city-master/new-city-master.module#NewCityMasterModule",
      },
      {
        path: "new-pincode",
        loadChildren:
          "../Masters/new-pincode/new-pincode.module#NewPincodeModule",
      },
      {
        path: "new-configurations",
        loadChildren:
          "../Masters/new-configurations/new-configurations.module#NewConfigurationsModule",
      },
      {
        path: "charges-new",
        loadChildren:
          "../Masters/charges-new/charges-new.module#ChargesNewModule",
      },
      {
        path: "newfuel",
        loadChildren:
          "../Masters/newfuel/fuelbycity/fuelbycity.module#fuelbycityModule",
      },
      {
        path: "newfuelpricepumpwise",
        loadChildren:
          "../Masters/newFuelPricePumpWise/fuel-pump-wise/fuel-pump-wise.module#fuelpumpwiseModule",
      },
      {
        path: "NewTaxExemptionsModule",
        loadChildren:
          "../Accouting/NewTaxExemption/new-taxexemption/new-taxexemption.module#TaxExemptionModule",
      },
      {
        path: "accounting-period-new",
        loadChildren:
          "../Accouting/accounting-period-new/accounting-period-new.module#AccountingPeriodNewModule",
      },
      {
        path: "opening-balance-new",
        loadChildren:
          "../Accouting/opening-balance-new/opening-balance-new.module#OpeningBalanceNewModule",
      },
      {
        path: "NewManageTds",
        loadChildren:
          "../Accouting/newmanagetds/new-managetds/new-managetds.module#ManageTdsModule",
      },
      {
        path: "newVehicletype",
        loadChildren:
          "../Masters/new-vehicletype/new-vehicletype/new-vehicletype.module#VehicleTypeModule",
      },
      //added by rahul 03-11-2023
      {
        path: "NewReasonMaster",
        loadChildren:
          "../Masters/New-ReasonMaster/new-reasonmaster/new-reasonmaster.module#NewReasonmasterModule",
      },
      {
        path: "new-products",
        loadChildren:
          "../Masters/Products/new-products/new-products.module#NewProductsModule",
      },
      {
        path: "new-target",
        loadChildren: "../Masters/target-new/target-new.module#NewTargetModule",
      },
      {
        path: "new-journal-entry",
        loadChildren:
          "../Accouting/new-journal-entry/new-journal-entry.module#NewJournalEntryModule",
      },
      {
        path: "new-invoice-type",
        loadChildren:
          "../Accouting/invoice-type/invoice-type.module#InvoiceTypeModule",
      },
      {
        path: "new-courier",
        loadChildren:
          "../Orders/new-courier/new-courier.module#NewCourierModule",
      },
      {
        path: "truck-load-new",
        loadChildren:
          "../Orders/truck-load-new/truck-load-new.module#TruckLoadNewModule",
      },
      //added by vithujan 15-02-2024 - Siddarth
      {
        path: "sales-invoice-new",
        loadChildren:
          "../Sales/sales-invoice-new/sales-invoice-new.module#SalesInvoiceNewModule",
      },
      // {
      //   path: "trip-planning-map",
      //   loadChildren: "../trip-planning-map/trip-panning-map.module#TripPlanningMapModule",
      // },

      // Added By Pratyush 13-05-2024
      {
        path: "VehicleTracking",
        loadChildren:
          "../Fleet/vehicle-tracking/vehicle-tracking.module#VehicleTrackingModule",
      },

      //Added By Pratyush 15-05-2024
      {
        path: "AttachmentFolders",
        loadChildren:
          "../Fleet/new-attachment-folders/new-attachment-folders.module#NewAttachmentModule",
      },

      {
        path: "FtlList",
        loadChildren:
          "../full-truck-load/ftl-list/ftl-list.module#FtlListModule",
      },
      {
        path: "FtlDetails",
        loadChildren:
          "../full-truck-load/ftldetails/ftldetails.module#FtlDetailsModule",
      },
      {
        path: "NewBookingList",
        loadChildren:
          "../New-Bookings/new-bookinglist/new-bookinglist.module#NewBookingListModule",
      },
      {
        path: "order-allocation-rule",
        loadChildren:
          "../order-allocation-rule/order-allocation-rule.module#OrderAllocationRuleModule",
      },
      {
        path: "Wallet",
        loadChildren: "../wallet/wallet.module#WalletModule",
      },
      {
        path: "NewPurchaseOrder",
        loadChildren:
          "../newDesign/newpurchase-order/newpurchase-order.module#PurchaseOrderModule",
      },
      {
        path: "po_returnPurchaseOrder",
        loadChildren:
          "../newDesign/returnPurchaseOrder/returnPurchaseOrder.module#returnPurchaseOrderModule",
      },
      {
        path: "GoodsInward",
        loadChildren:
          "../newDesign/goods-inward/goods-inward.module#GoodsInwardModule",
      },
      {
        path: "so_GoodsOutward",
        loadChildren:
          "../newDesign/goods-outward/goods-outward.module#GoodsOutwardModule",
      },
      // {
      //   path: "InwardRegister",
      //   loadChildren: "../newDesign/inward-register/inward-register.module#InwardRegisterModule",
      // },
      {
        path: "OutwardRegister",
        loadChildren:
          "../newDesign/outward-register/outward-register.module#OutwardRegisterModule",
      },

      {
        path: "AccountReports",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/newaccounts.module#NewAccountsModule",
      },

      {
        path: "InventoryReport",
        loadChildren:
          "../Reports/Inventory/inventory-report/inventory-report.module#InventoryReportModule",
      },
      {
        path: "NewOperationalReports",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/newoperational-report.module#NewOperationalReportsModule",
      },
      {
        path: "Masters",
        loadChildren:
          "../Reports/NewMasters/new-masters/newmasters.module#NewMastersReportsModule",
      },
      {
        path: "BranchMasters",
        loadChildren:
          "../Reports/NewMasters/new-masters/branch-master/branchmaster.module#BranchMasterModule",
      },
      {
        path: "CustomersMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/customer-master/customermaster.module#CustomerMasterModule",
      },
      {
        path: "TransporterMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/transporter-master/Transportermaster.module#TransporterMasterModule",
      },
      {
        path: "VendorMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/vendor-master/vendormaster.module#VendorMasterModule",
      },
      {
        path: "COAMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/coamaster/coamaster.module#COAMasterModule",
      },
      {
        path: "OpeningBalanceMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/opening-balance-master/opening-balance-master.module#OpeningBalanceMasterModule",
      },
      {
        path: "ChargeListMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/charge-list-master/chargelistmaster.module#ChargeListMasterModule",
      },
      {
        path: "TaxMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/tax-master/taxmaster.module#TaxMasterModule",
      },
      {
        path: "TDSMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/tdsmaster/tdsmaster.module#TDSMasterModule",
      },
      {
        path: "ExemptMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "ProductsMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/product-master/productmaster.module#ProductmasterModule",
      },
      {
        path: "CategoryMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/category-master/categorymaster.module#CategorymasterModule",
      },
      {
        path: "WarehouseMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/warehouse-master/warehousemaster.module#WarehousemasterModule",
      },
      {
        path: "CustomerRates",
        loadChildren:
          "../Reports/NewMasters/new-masters/customer-rates/customerrates.module#CustomerratesModule",
      },
      {
        path: "SupplierRates",
        loadChildren:
          "../Reports/NewMasters/new-masters/supplier-rates/supplierrates.module#SupplierratesModule",
      },
      {
        path: "SalesTargets",
        loadChildren:
          "../Reports/NewMasters/new-masters/sales-targets/salestargets.module#SalestargetsModule",
      },
      {
        path: "TripList",
        loadChildren:
          "../Reports/NewMasters/new-masters/trip-list/triplist.module#TriplistModule",
      },
      {
        path: "eWayBillList",
        loadChildren:
          "../Reports/NewMasters/new-masters/ewaybill-list/ewaybilllist.module#EwaybilllistModule",
      },
      {
        path: "OperationActivity",
        loadChildren:
          "../Reports/NewMasters/new-masters/operation-activity/operationactivity.module#OperationActivityModule",
      },
      {
        path: "AccountsActivity",
        loadChildren:
          "../Reports/NewMasters/new-masters/accounts-activity/accountsactivity.module#AccountsActivityModule",
      },
      {
        path: "MastersActivity",
        loadChildren:
          "../Reports/NewMasters/new-masters/master-activity/master-activity.module#MasterActivityModule",
      },
      {
        path: "DailyTripsMasters",
        loadChildren:
          "../Reports/NewMasters/new-masters/daily-trips/dailytrips.module#DailyTripsModule",
      },
      {
        path: "UsersMaster",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "UserHeirarchy",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "Vehicles",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "Drivers",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "Products",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "TransportService",
        loadChildren:
          "../Reports/NewMasters/new-masters/exempt-master/exemptmaster.module#ExemptMasterModule",
      },
      {
        path: "GeneralLedgerRP",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/general-ledger-rp/generalledgerrp.module#GeneralLedgerRPModule",
      },
      {
        path: "BankAccountRP",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/bank-account-rp/bankaccountrp.module#BankAccountRPModule",
      },
      {
        path: "CardAccountRP",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/card-account-rp/cardaccountrp.module#CardAccountRPModule",
      },
      {
        path: "CashAccountRP",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/cash-account-rp/cashaccountrp.module#CashAccountRPModule",
      },
      {
        path: "GLAccountRP",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/glaaccount-rp/glaaccountrp.module#GLAAccountRPModule",
      },
      {
        path: "SalesRegisterReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/sales-register/salesregister.module#SalesregisterModule",
      },
      {
        path: "SalesDetailReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/sales-detail-register/salesdetailregister.module#SalesdetailregisterModule",
      },
      {
        path: "SalesReturnsRegister",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/sales-returns-register/salesreturnsregister.module#SalesreturnsregisterModule",
      },
      {
        path: "PurchaseRegisterReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/purchase-register/purchaseregister.module#PurchaseregisterModule",
      },
      {
        path: "PurchaseDetailReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/purchase-detail-register/purchasedetailregister.module#PurchasedetailregisterModule",
      },
      {
        path: "SalesDetailRegisterPivot",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/sales-detail-register-pivot/salesdetailregisterpivot.module#SalesdetailregisterpivotModule",
      },
      {
        path: "ReceiptRegisterReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/receipt-register/receiptregister.module#ReceiptregisterModule",
      },
      {
        path: "CashReceiptReportReceivable",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/cash-receipt-report/cashreceiptreport.module#CashreceiptreportModule",
      },
      {
        path: "TDSRegisterReceivable",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/tds-register/tdsregister.module#TdsregisterModule",
      },
      {
        path: "ReceivableAgingReport",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/receivable-aging-report/receivableagingreport.module#ReceivableagingreportModule",
      },
      {
        path: "GSTSales",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/gst-sales/gstsales.module#GstsalesModule",
      },
      {
        path: "PendingTripsForInvoice",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/pending-trip-for-invoice/pendingtripforinvoice.module#PendingtripforinvoiceModule",
      },
      {
        path: "SalesRegisterMultipointReceivable",
        loadChildren:
          "../Reports/NewAccounts/new-accounts/sales-register-multipoint/salesregistermultipoint.module#SalesregistermultipointModule",
      },

      {
        path: "PurchaseOrderRP",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/purchaseorder-rp/purchaseorderRP.module#PurchaseorderRPModule",
      },
      {
        path: "PurchaseOrderRPDetail",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/purchaseorderrpdetail/purchaseorderdetail.module#PurchaseOrderDetailModule",
      },
      {
        path: "SalesOrderReport",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/salesorder-rp/salesorder-rp.module#SalesOrderReportModule",
      },
      {
        path: "SalesOrderDetail",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/salesorderdetail-rp/salesorderdetail-rp.module#salesorderdetailRPModule",
      },
      {
        path: "OutwardProfitAndLoss",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/outward-profit-and-loss-rp/outwardprofitandloss.module#OutwardProfitAndLossRPModule",
      },


      {
        path: "PurchaseReturnOrder",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/purchase-return-order/purchasereturnorder.module#PurchasereturnorderModule",
      },
      {
        path: "SalesReturnOrder",
        loadChildren:
          "../Reports/NewOperations/newoperational-report/sales-return-order/salesreturnorder.module#SalesreturnorderModule",
      },
      {
        path: "InwardRegister",
        loadChildren:
          "../Reports/Inventory/inventory-report/inward-register/inward-register.module#InwardRegisterModule",
      },
      {
        path: "StockLedger",
        loadChildren:
          "../Reports/Inventory/inventory-report/stock-ledger-report/stock-ledger-report.module#StockLedgerReportModule",
      },
      {
        path: "StockSummary",
        loadChildren:
          "../Reports/Inventory/inventory-report/stock-summary/stock-summary.module#StockSummaryModule",
      },
      {
        path: "StockDetails",
        loadChildren:
          "../Reports/Inventory/inventory-report/stock-details/stock-details.module#StockDetailsModule",
      },
      {
        path: "StockMovement",
        loadChildren:
          "../Reports/Inventory/inventory-report/stock-movemenet/stock-movement.module#StockMovementModule",
      },
      {
        path: "so_rpt_outwardRegister",
        loadChildren:
          "../Reports/Inventory/inventory-report/so_rpt_outwardRegister/so_rpt_outwardRegister.module#so_rpt_outwardRegisterModule",
      },
      {
        path: "Newtracking",
        loadChildren:
          "../newDesign/new-tracking/new-tracking.module#NewTrackingModule",
      },
      {
        path: "Shipment",
        loadChildren: "../newship-now/newship-now.module#NewshipNowModule",
      },
      {
        path: "NewBidding",
        loadChildren:
          "../newDesign/new-bidding/new-bidding.module#NewBiddingModule",
      },
      {
        path: "NewSelfFulfilled",
        loadChildren:
          "../newDesign/self-fullfilled/self-fullfilled.module#SelfFullfilledModule",
      },
      {
        path: "newratecheck",
        loadChildren:
          "../new-ratecheck/new-ratecheck.module#NewRatecheckModule",
      },
    ],
  },
  // end pratiksha

  {
    path: "customers",
    loadChildren: "./new-app/new-app.module#NewModule",
  },
  {
    path: "transporters",
    loadChildren:
      "./transporter-app/transporter-app.module#TransporterAppModule",
  },
  {
    path: "home",
    loadChildren: "./home/home.module#HomeModule",
  },
  {
    path: "home1",
    loadChildren: "./home/home1.module#Home1Module",
  },
  // {
  //   path: "ssologin/:email/:password",
  //   loadChildren: "./ssologin/ssologin.module#SsologinModule",
  // },
  {
    path: "CustomerVerification",
    loadChildren:
      "../NewRegistration/customer-verification/customer-verification.module#CustomerVerificationModule",
  },
  {
    path: "TermsCondition",
    loadChildren:
      "../new-terms-conditions/new-terms-conditions.module#NewTermsConditionsModule",
  },
  {
    path: "PrivacyPolicy",
    loadChildren:
      "../newprivacy-policy/newprivacy-policy.module#NewprivacyPolicyModule",
  },
  {
    path: "RefundPolicy",
    loadChildren:
      "../new-refundpolicy/new-refundpolicy.module#NewRefundpolicyModule",
  },

  {
    path: "**",
    redirectTo:
      environment.apiUrl == "https://sawariya.ifreightbox.net/" ||
        environment.apiUrl == "https://ximble.ifreightbox.net/"
        ? "index2"
        : "index",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ThemeRoutingModule { }
